export const FILE_PREVIEW_STYLES = {
  base: "rounded-sm border border-border-medium bg-subtle p-1 hover:!bg-accent-blue-background focus-visible:!bg-accent-blue-background active:border-accent",
  upload: "border-dashed",
  selected: "border-accent border-2",
  sizes: {
    expanded: "w-[60px] h-[68px]",
    collapsed: "w-[60px] h-[32px]",
  },
} as const;
